var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15743_43004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 9.27237H3.01279V8.02237H8.92188C9.46733 8.02237 9.91809 7.92768 10.2742 7.73828C10.6302 7.5451 10.8954 7.28374 11.0696 6.95419C11.2438 6.62086 11.331 6.24207 11.331 5.81783C11.331 5.39358 11.2438 5.01669 11.0696 4.68715C10.8954 4.35381 10.6302 4.09245 10.2742 3.90305C9.91809 3.70987 9.46733 3.61328 8.92188 3.61328H6.26279V13.9996H4.8537V2.36328H8.92188C9.78551 2.36328 10.4976 2.52048 11.0582 2.83487C11.6188 3.14927 12.0355 3.56783 12.3082 4.09055C12.581 4.61328 12.7173 5.18904 12.7173 5.81783C12.7173 6.44661 12.581 7.02237 12.3082 7.5451C12.0355 8.06783 11.6188 8.48639 11.0582 8.80078C10.4976 9.11518 9.78551 9.27237 8.92188 9.27237ZM8.83097 10.3633V11.6133H3.01279V10.3633H8.83097Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15743_43004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuble);
export default __webpack_public_path__ + "static/media/iconRuble.49aff39abe769cba315525b860374675.svg";
export { ForwardRef as ReactComponent };